import parameters from './parameters';

const API_PREFIX = 'api/v2';

export const CONFIG = {
    ENVIRONMENT: {
        DEBUG: false,
        PRODUCTION: (typeof parameters.PRODUCTION === 'undefined') ? true : parameters.PRODUCTION,
        MOCK_BACKEND: parameters.MOCK_BACKEND || false,
        REDUX_LOGGER: parameters.REDUX_LOGGER || false,
        REDUX_DEVTOOLS: parameters.REDUX_DEVTOOLS || false,
        TOKEN_COOKIE_DOMAIN: parameters.TOKEN_COOKIE_DOMAIN || null
    },
    APPLICATION: {
        TRANSLATOR: {
            FALLBACKS: 'en',
            AVAILABLE_LANGUAGES: [
                {name: 'LANGUAGES.ENGLISH', key: 'en'},
                {name: 'LANGUAGES.POLISH', key: 'pl'},
                {name: 'LANGUAGES.UKRAINIAN', key: 'uk'},
                {name: 'LANGUAGES.RUSSIAN', key: 'ru'}
            ],
        },
        PATTERNS: {
            BANK_ALLOWED_CHARS: /^[0-9A-z- ęóąśłżźćń/.,()]+$/i
        },
        UPLOAD: {
            DOCUMENT: {
                TYPE: ['image/png', 'image/jpg', 'image/jpeg', 'image/bmp', 'image/tiff', 'application/pdf'],
                MAX_SIZE: '8MB'
            }
        },
        CUSTOMER_SERVICE: {
            PHONE: {
                GB: '+44 20 3318 7267',
                PL: '+48 58 500 86 75',
                IE: '+353 1 485 4489',
            },
            EMAIL: {
                HELP: {
                    PL: 'pomoc@easysend.pl',
                    EN: 'help@easysend.pl'
                },
                BUSINESS: {
                    PL: 'biznes@easysend.pl',
                    EN: 'business@easysend.pl'
                }

            },
            WORKING_HOURS: {
                GB: {
                    WEEKDAYS: '09:00 - 15:00',
                    WEEKEND: '09:00 - 14:00'
                },
                PL: {
                    WEEKDAYS: '10:00 - 16:00',
                    WEEKEND: '10:00 - 15:00'
                },
                IE: {
                    WEEKDAYS: '10:00 - 16:00',
                    WEEKEND: '10:00 - 15:00'
                }
            }
        },
        AUTOLOGOUT: {
            TIME_TO_MODAL: parameters.AUTOLOGOUT || 8.5 * 60,
            TIME_TO_LOGOUT_AFTER_MODAL: 1.5 * 60
        },
        SIGN: {
            AUTOCOMPLETE: parameters.PASSWORD_AUTOCOMPLETE_ENABLED || false,
            SOCIAL_MEDIA_AVAILABILITY: {
                FACEBOOK: parameters.FACEBOOK_LOGIN_AVAILABLE,
                GOOGLE: parameters.GOOGLE_LOGIN_AVAILABLE,
            }
        }
    },
    API: {
        CONFIG: {
            BASE_URL: parameters.BASE_URL,
            CLIENT_ID: parameters.CLIENT_ID,
            CLIENT_SECRET: parameters.CLIENT_SECRET
        },
        DEPOSITS_CSV: `${API_PREFIX}/deposits-csv`,
        RESERVATIONS_CSV: `${API_PREFIX}/reservations-csv`,
        TRANSFERS_CSV: `${API_PREFIX}/transfers/csv`,
        OPERATIONS_CSV: `${API_PREFIX}/account/:currency/operations/csv`,
        FACEBOOK_URL: `${API_PREFIX}/token/facebook`,
        GOOGLE_URL: `${API_PREFIX}/token/google`
    },
    STATIC_LINKS: {
        WEBSITE: {
            PL: parameters.WEBSITE_URI,
            EN: parameters.WEBSITE_URI + '/en',
            UK: parameters.WEBSITE_URI + '/ua',
            RU: parameters.WEBSITE_URI + '/ru'
        },
        TERMS: {
            PL: parameters.WEBSITE_URI + '/regulamin',
            EN: parameters.WEBSITE_URI + '/en/terms-and-conditions',
            UK: parameters.WEBSITE_URI + '/ua/umovy-vykorystannia',
            RU: parameters.WEBSITE_URI + '/ru/usloviya-i-polozheniya'
        },
        PRIVACY_POLICY: {
            PL: parameters.WEBSITE_URI + '/ochrona-danych-osobowych',
            EN: parameters.WEBSITE_URI + '/en/privacy-policy',
            UK: parameters.WEBSITE_URI + '/ua/polityka-konfidentsiinosti',
            RU: parameters.WEBSITE_URI + '/ru/politika-konfidentsialnosty'
        },
        AGENTS: {
            PL: parameters.WEBSITE_URI + '/agenci',
            EN: parameters.WEBSITE_URI + '/en/agents',
            UK: parameters.WEBSITE_URI + '/ua/ahenty',
            RU: parameters.WEBSITE_URI + '/ru/agenty'
        },
        CONTACT: {
            PL: parameters.WEBSITE_URI + '/kontakt',
            EN: parameters.WEBSITE_URI + '/en/contact',
            UK: parameters.WEBSITE_URI + '/ua/kontakty',
            RU: parameters.WEBSITE_URI + '/ru/kontakty'
        }
    },
    LIBRARIES: {
        FACEBOOK: {
            APP_ID: parameters.FACEBOOK_APP_ID,
            API_VERSION: '2.10'
        },
        GOOGLE: {
            APP_ID: parameters.GOOGLE_APP_ID
        },
        WORLDPAY: {
            KEY: parameters.WORLDPAY_KEY,
            API_URL: 'https://api.worldpay.com/v1',
            CONFIRMATION_URL: parameters.THREEDS_CONFIRMATION_URL,
        },
        CHECKOUT: {
            KEY_GB: parameters.CHECKOUT_KEY_GB,
            KEY_SAS: parameters.CHECKOUT_KEY_SAS,
        },
        HOTJAR: {
            ID: parameters.HOTJAR_ID,
            ID_BUSINESS: parameters.HOTJAR_ID_BUSINESS,
        },
        GOOGLE_ANALYTICS: {
            ID: parameters.GOOGLE_ANALYTICS_ID
        },
        TAWK: {
            IS_ENABLED: (typeof parameters.TAWK_ENABLED === 'undefined') ? true : parameters.TAWK_ENABLED,
            POLISH_CHANNEL: '556700777e314cc255082cb3/1ivn9548g',
            ENGLISH_CHANNEL: '556700777e314cc255082cb3/default',
            RUSSIAN_CHANNEL: '556700777e314cc255082cb3/1ivnamp0c',
            UKRAINIAN_CHANNEL: '556700777e314cc255082cb3/1ivndias5'
        },
        NETVERIFY: {
            REDIRECT_URL: parameters.NETVERIFY_REDIRECT_URL,
        },
        SUPPORTED_BROWSERS: {
            msie: '11',
            msedge: '13',
            firefox: '47',
            chrome: '49',
            safari: '9',
            opera: '39',
            android: '4.2'
        },
        PUSHER: parameters.PUSHER,
        RAVEN: parameters.RAVEN,
        FIREBASE: parameters.FIREBASE,
        FEEDBACK_WIDGET: {
            ID: parameters.FEEDBACK_WIDGET_ID,
        },
    }
};



// WEBPACK FOOTER //
// ./src/app/config/config.js